<template>
  <div class="form-card">
    <div class="form-card__header">
      <div class="form-card__header-icon"><i class="pi pi-image"></i></div>
      <div>
        <p class="form-card__title">الصور</p>
        <p class="form-card__subtitle">الصورة المصغّرة تظهر في القوائم، وصورة الغلاف في صفحة التفاصيل</p>
      </div>
    </div>
    <div class="form-card__body">
      <div class="ds-field-grid">
        <div class="form-field">
          <label class="field-label">الصورة المصغّرة <span class="optional">اختياري</span></label>
          <label :class="['upload-zone', 'upload-zone--image', { 'upload-zone--has-file': preview.image }]">
            <template v-if="preview.image">
              <img :src="preview.image" class="upload-zone__preview" alt="" />
              <div class="upload-zone__overlay"><i class="pi pi-camera"></i> تغيير الصورة</div>
            </template>
            <template v-else>
              <div class="upload-zone__icon"><i class="pi pi-cloud-upload"></i></div>
              <p class="upload-zone__label">اضغط لاختيار صورة</p>
              <p class="upload-zone__hint">JPG, PNG</p>
            </template>
            <input type="file" accept="image/*" @change="onFile($event, 'image')" />
          </label>
        </div>
        <div class="form-field">
          <label class="field-label">صورة الغلاف <span class="optional">اختياري</span></label>
          <label :class="['upload-zone', 'upload-zone--image', { 'upload-zone--has-file': preview.cover_image }]">
            <template v-if="preview.cover_image">
              <img :src="preview.cover_image" class="upload-zone__preview" alt="" />
              <div class="upload-zone__overlay"><i class="pi pi-camera"></i> تغيير الصورة</div>
            </template>
            <template v-else>
              <div class="upload-zone__icon"><i class="pi pi-cloud-upload"></i></div>
              <p class="upload-zone__label">اضغط لاختيار صورة</p>
              <p class="upload-zone__hint">JPG, PNG</p>
            </template>
            <input type="file" accept="image/*" @change="onFile($event, 'cover_image')" />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Shared "Images" product-editor section (Courses / Academic Years). The parent
// owns both the preview URLs (for display) and the raw File objects (for upload) —
// this component only forwards the picked file via `file-change`.
export default {
  name: 'ProductImagesSection',
  props: {
    preview: { type: Object, required: true }, // { image, cover_image }
  },
  emits: ['file-change'],
  methods: {
    onFile(event, field) {
      const file = event.target.files[0];
      if (!file) return;
      this.$emit('file-change', field, file);
    },
  },
};
</script>
